import { ButtonHTMLAttributes, FC } from 'react';
import classnames from 'classnames';

import styles from './LineButton.module.scss';

interface Props {
  dataTestId?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  outline?: boolean;
  shadow?: boolean;
  size?: 'large' | 'normal';
  testId?: string;
  type?: ButtonHTMLAttributes<HTMLDivElement>['type'];
  variant?: 'primary' | 'secondary';
}

const LineButton: FC<Props> = ({ onClick, testId = 'line-button' }) => (
  <div className={classnames(styles['line-button-new'])}>
    {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
    <div className={classnames(styles['cover'])} onClick={onClick} data-test-id={testId}>
      <div className={classnames(styles['logo'])}></div>
      <div className={classnames(styles['text'])}>LINEでログイン</div>
    </div>
  </div>
);

export type { Props as LineButtonProps };
export default LineButton;
